<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <v-flex xs4>
        <v-card>
          <v-card-text>
            <h2>Группа: {{ group.name}} </h2>
            <p>Организация: {{ group.organization.name}}</p>
            <p>Категория: {{ categoryName }}</p>
            <p>Дата аттестации: {{ group.attestationInfo.date }}</p>
            <p>Статус аттестации: {{ group.attestationInfo.status }}</p>
            <p v-if="isAttestable">
              <v-btn v-if="attestationInfoReadyToStart" color="primary" block @click="startAttestation">
                Начать аттестацию
              </v-btn>
              <v-btn v-if="attestationInfoReadyToEnd" color="primary" block @click="endAttestation">
                Закончить аттестацию
              </v-btn>
            </p>
            <p v-else-if="isTrainingable">
              <v-btn v-if="trainingReadyToStart" @click="startTraining" color="primary" flat block>
                Начать тренировку
              </v-btn>
              <v-btn v-if="trainingReadyToEnd" @click="endTraining" color="primary" flat block>
                Закончить тренировку
              </v-btn>
            </p>
            <v-btn v-if="editable" color="primary" block flat
                   :to="{name: 'AdminGroupEdit', params: {id: group.id.toString()}}">
              Редактировать группу
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs8 ml-3>
        <v-card>
          <v-card-text>
            <v-layout>
              <h2>Аттестуемые</h2>
              <v-spacer></v-spacer>
              <v-btn v-if="editable" class="mr-0 primary" :to="{name: 'AdminStudentAdd', query: {group: group.id}}">
                Добавить
              </v-btn>
            </v-layout>
            <DataTable :headers="headers" :items="sortedStudents" class="table">
              <tr slot-scope="props">
                <td class="text-xs-center">{{ props.index +1 }}</td>
                <td>{{ props.item.uin }}</td>
                <td class="text-xs-center">{{ props.item.status }}</td>
                <td class="text-xs-center">{{ props.item.bestTrainingStatus }}</td>
                <td class="justify-center layout px-0">
                  <v-btn flat icon
                         :disabled="props.item.status === 'Не начинал' && props.item.bestTrainingStatus === 'Не начинал'"
                         :to="{name: 'AdminAttestationInfoStudentIndex', params: {id: props.item.id.toString()}}">
                    <v-icon small>visibility</v-icon>
                  </v-btn>
                  <v-btn flat icon @click="deleteConfirm(props.item)"
                         :disabled="props.item.status !== 'Не начинал' || props.item.bestTrainingStatus!== 'Не начинал'">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </DataTable>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <DeleteConfirmDialog :dialog="deleteDialog" @confirm="confirm">
      <p>Название: {{ deleteDialog.item.uin }}</p>
    </DeleteConfirmDialog>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import GroupService from '@/services/GroupService'
import SettingsService from '@/services/SettingsService'
import CategoryService from '@/services/CategoryService'
import DataTable from '@/components/fragments/DataTable'
import StudentService from '@/services/StudentService'
import DeleteConfirmDialog from '@/components/fragments/DeleteConfirmDialog'
import ErrorDialog from '@/components/fragments/ErrorDialog'
import AttestationService from '@/services/AttestationService'
import DateUtils from '@/utils/DateUtils'

export default {
  components: {ErrorDialog, DeleteConfirmDialog, DataTable},
  props: {
    id: String
  },
  data: () => ({
    group: GroupService.getDefaultItem(),
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'УИН', align: 'left', sortable: false},
      {text: 'Аттестация', align: 'center', sortable: false, width: 200},
      {text: 'Тренировка', align: 'center', sortable: false, width: 200},
      {text: 'Действия', align: 'center', sortable: false, width: 156}
    ],
    deleteDialog: {
      status: false,
      item: StudentService.getDefaultItem()
    },
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при удалении'
    },
    groupService: undefined,
    studentService: undefined,
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.group.name + ' - ' + this.$route.meta.title)
    },
    categoryName () {
      return this.group.category ? CategoryService.getList()[this.group.category - 1].text : ''
    },
    sortedStudents () {
      return this.group.students.slice().sort(function (a, b) {
        if (a.uin > b.uin) return 1
        if (a.uin < b.uin) return -1
        return 0
      })
    },
    isAttestable () {
      return this.group.attestationInfo.date === DateUtils.dateToString(new Date())
    },
    attestationInfoReadyToStart () {
      return ['В процессе', 'Закончена'].indexOf(this.group.attestationInfo.status) === -1 && this.isAttestable
    },
    attestationInfoReadyToEnd () {
      return this.group.attestationInfo.status === 'В процессе'
    },
    isTrainingable () {
      return ['Тренировка', 'Не началась'].indexOf(this.group.attestationInfo.status) !== -1
    },
    trainingReadyToStart () {
      return ['Тренировка'].indexOf(this.group.attestationInfo.status) === -1 && this.isTrainingable
    },
    trainingReadyToEnd () {
      return this.group.attestationInfo.status === 'Тренировка'
    },
    editable () {
      return this.groupService.isEditable(this.group.attestationInfo.status)
    }
  },
  created () {
    this.groupService = new GroupService(this.$store)
    this.studentService = new StudentService(this.$store)
    this.attestationService = new AttestationService(this.$store)
    this.loadGroup()
  },
  methods: {
    deleteConfirm (item) {
      this.deleteDialog.item = item
      this.deleteDialog.status = true
    },
    confirm () {
      this.studentService.deleteItem(this.deleteDialog.item.id, (data) => {
        if (data.status) {
          this.loadGroup()
        } else {
          this.errorDialog.errors = data.errors
          this.errorDialog.status = true
        }
      })
    },
    loadGroup () {
      this.groupService.getItem(this.id, (data) => {
        this.group = data.item
      }, {
        students: true
      })
    },
    toPdf (id) {
      this.attestationService.resultToPdf(id, blob => {
        this.fileUrl = URL.createObjectURL(blob)
        window.open(process.env.SITE_URL + '/pdf/view?link=' + this.fileUrl)
        window.focus()
      })
    },
    startAttestation () {
      this.attestationService.startAttestation(this.id, (data) => {
        if (data.status) {
          this.loadGroup()
        }
      })
    },
    endAttestation () {
      this.attestationService.endAttestation(this.id, (data) => {
        if (data.status) {
          this.loadGroup()
        }
      })
    },
    startTraining () {
      this.attestationService.startTraining(this.id, (data) => {
        if (data.status) {
          this.loadGroup()
        }
      })
    },
    endTraining () {
      this.attestationService.endTraining(this.id, (data) => {
        if (data.status) {
          this.loadGroup()
        }
      })
    }
  }
}
</script>

<style scoped>
.table {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/group/View.vue